import { FormControl } from '@angular/forms';

import { CalendarProviderKey } from '@libs/src/calendar/calendar.types';

export const CalendarProviders = {
  GOOGLE: 'google',
  MICROSOFT: 'microsoft',
} as const;
export const GoogleAuthType = {
  DOMAIN_WIDE: 'domain-wide',
  OAUTH2: 'oauth2',
} as const;

export interface CalendarFormGroup {
  microsoftTenantId: FormControl<string>;
  isGoogleWorkspaceConnected: FormControl<boolean>;
  gcpServiceAccountKey: FormControl<string>;
  googleAuthType: FormControl<'domain-wide' | 'oauth2'>;
  provider: FormControl<CalendarProviderKey | 'none'>;
}
